import React, { useState, useEffect } from "react";
import axios from "axios";
import styles from "./ABMListProveedor.module.css";
import DownloadButton from "../DownloadButton/DownloadButton";
import EditABM from "../EditABM/EditABM";
import DownButton from "../DownButton/DownButton";
import CreateABM from "../CreateABM/CreateABM";
import PrintButton from "../PrintButton/PrintButton";
import { TiDelete } from "react-icons/ti";
import { AiFillCheckCircle } from "react-icons/ai";

const AMBListProveedor = ({
  data,
  displayList,
  setTypeDocument,
  setFileId,
  reloadChildData,
}) => {
  const [aMB, setAMB] = useState([]);
  const [documentDeletedId, setDocumentDeletedId] = useState(null);

  useEffect(() => {
    const userId = data.id;
    const apiUrl = `${process.env.REACT_APP_ABM_OF_DOCUMENT_GET_ALL}?userId=${userId}`;

    const fetchData = async () => {
      try {
        const response = await axios.get(apiUrl);
        if (response.status === 204) {
          setAMB([]);
        } else {
          setAMB(response.data);
        }
      } catch (error) {}
    };

    fetchData();
  }, [data, reloadChildData, documentDeletedId]);

  const combinedValues = [
    {
      variable: "Constancia de monotributo",
    },
    {
      variable: "DNI",
    },
    {
      variable: "DJ PEP AUTORIDADES (134/2018)",
    },
    {
      variable: "ESTATUTO - REFORMA ESTATUTARIA",
    },
    {
      variable: "ULTIMO BALANCE CERTIFICADO",
    },
    {
      variable: "DJ DE PERSONAS JURIDICAS",
    },
    {
      variable: "Otra documentación",
    },
  ].map((item) => {
    const matchingDocument = aMB.find(
      (doc) => doc.typeDocument === item.variable
    );

    if (matchingDocument) {
      return {
        id: matchingDocument.id,
        file: "Yes",
        estado: <AiFillCheckCircle style={{ color: "green" }} />,
        variable: item.variable,
        valorObtenido: matchingDocument.description,
        riesgoObtenido: `${
          matchingDocument.expiresAt === "1"
            ? "1 Mes"
            : matchingDocument.expiresAt + " Meses"
        }`,
      };
    } else {
      return {
        estado: <TiDelete style={{ color: "red" }} />,
        file: "No",
        variable: item.variable,
        valorObtenido: "-",
        riesgoObtenido: "-",
      };
    }
  });

  const OpenForm = (viewOrNot) => {
    displayList(viewOrNot);
  };

  return (
    <div className={styles.bodyMDR}>
      <>
        <table className={styles.tableMDR}>
          <thead>
            <tr>
              <th>Estado</th>
              <th>Tipo de archivo</th>
              <th>Descripcion</th>
              <th>Fecha de vencimiento</th>
              <th>Alta</th>
              <th>Baja</th>
              <th>Modificacion</th>
              <th>Descargar</th>
              <th>Imprimir</th>
            </tr>
          </thead>
          <tbody>
            {combinedValues.map((item, index) => (
              <tr key={index}>
                <td>{item.estado}</td>
                <td>{item.variable}</td>
                <td>{item.valorObtenido}</td>
                <td className={styles.numberSquareMDR}>
                  <div className={styles.numberContainerMDR}>
                    <p>{item.riesgoObtenido}</p>
                  </div>
                </td>
                <td>
                  {item.file === "No" ? (
                    <CreateABM
                      setTypeDocument={setTypeDocument}
                      typeDocument={item.variable}
                      OpenForm={OpenForm}
                    />
                  ) : (
                    <div></div>
                  )}
                </td>
                <td>
                  {item.file === "Yes" ? (
                    <DownButton
                      id={item.id}
                      onDocumentDeleted={setDocumentDeletedId}
                    />
                  ) : (
                    <div></div>
                  )}
                </td>
                <td>
                  {item.file === "Yes" ? (
                    <EditABM
                      setTypeDocument={setTypeDocument}
                      typeDocument={item.variable}
                      id={item.id}
                      setFileId={setFileId}
                      OpenForm={OpenForm}
                    />
                  ) : (
                    <div></div>
                  )}
                </td>
                <td>
                  {item.file === "Yes" ? (
                    <DownloadButton id={item.id} typeDocument={item.variable} />
                  ) : (
                    <div></div>
                  )}
                </td>
                <td>
                  {item.file === "Yes" ? (
                    <PrintButton id={item.id}/>
                  ) : (
                    <div></div>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </>
    </div>
  );
};

export default AMBListProveedor;
